import { useEffect, useState } from 'react';
import apiClient from '../api/client';
import env from '../config/env';

/** What the site showed before the admin could set these (Settings → General); used for anything left empty there. */
export const BUILT_IN_CONTACT = { email: 'info@skinnthrive.com', phone: '+91 8320206804', address: '' };

// Fetched once per page load and shared by every component that shows contact details.
let request = null;
const load = () => {
  if (env.isMock) return Promise.resolve({});
  if (!request) request = apiClient.get('/store-info').then((r) => r.data || {}).catch(() => ({}));
  return request;
};

/** The store's contact details as set in the admin, falling back to the built-in ones. */
export default function useStoreInfo() {
  const [info, setInfo] = useState({});
  useEffect(() => {
    let alive = true;
    load().then((data) => { if (alive) setInfo(data); });
    return () => { alive = false; };
  }, []);
  return {
    email: (info.contactEmail || '').trim() || BUILT_IN_CONTACT.email,
    phone: (info.contactPhone || '').trim() || BUILT_IN_CONTACT.phone,
    address: (info.storeAddress || '').trim() || BUILT_IN_CONTACT.address,
  };
}

/** For tests: forget the fetched details. */
export const resetStoreInfo = () => { request = null; };
